import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { Analytics } from '@vercel/analytics/react'
import { SpeedInsights } from '@vercel/speed-insights/react'
import { bootstrap, connect, useAdmin } from '@vtex/raccoon-next'
import { LocalStoragePersistenceProvider } from 'hooks'
import type { AppProps } from 'next/app'
import { retryFn } from 'shared'
import {
  AdminIntlProvider,
  BaseProviders,
  ErrorBoundary,
  MESSAGES_TYPE,
} from 'ui'
import { AnalyticsProvider } from '../src/providers/AnalyticsProvider'
import { FeatureWrapper } from '../src/providers/FeatureWrapper'
import '../tsdt.override.css'

const FIVE_MINUTES = 300000

connect()

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: FIVE_MINUTES,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      retry: (failureCount, error: any) =>
        retryFn({ params: { failureCount, error }, stopErrors: [401] }),
    },
  },
})

function App({ Component, pageProps }: AppProps) {
  const { production } = useAdmin()

  return (
    <>
      <BaseProviders>
        <QueryClientProvider client={queryClient}>
          <AdminIntlProvider messageTypes={[MESSAGES_TYPE.Promotions]}>
            <ErrorBoundary>
              <LocalStoragePersistenceProvider cacheKey="vtex.admin-promotions">
                <AnalyticsProvider>
                  <FeatureWrapper>
                    <Component {...pageProps} />
                  </FeatureWrapper>
                </AnalyticsProvider>
              </LocalStoragePersistenceProvider>
            </ErrorBoundary>
          </AdminIntlProvider>
          <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
      </BaseProviders>

      <Analytics debug={!production} />
      <SpeedInsights debug={!production} />
    </>
  )
}

export default bootstrap(App)
